export enum DuplicateContractRequestKey {
    ReviewAndSend = 'review-and-send',
    ViewExistingRequest = 'view-existing-requests'
}
